

export const ERROR_POST = "Unable To Connect To The Remote, Check Your Network Connections"
export const ERROR_ALL_INPUTS_REQUIRED = "All Inputs Are Required";
export const EmailRequired = "Email Required";
export const EmailRegistered = "Email Given Is Already Registered";
export const PasswordMisMatch = "Passwords Do Not Match";
export const validateEmailText = "Please Enter A Valid Email Address."
export const ValidPasswordText = "Password must be at least 8 characters, include at least one uppercase letter, one number, and one special character.";